import { SessionContext } from "@viamap/viamap2-common";
import { ADModalBody, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { ApplicationStateContext, actionAddAvailableFeature, actionRemoveAvailableFeature } from "src/states/ApplicationState";
import { GlassCheckbox } from "./MitGlassComponents";
import { Fragment, useContext } from "react";
import { ManagedWindow } from "src/WindowManager/WindowState";

/** Show current user Access Rights. For debugging use */
export function UserAccessRightsWindow(props: { managedWindow: ManagedWindow, onClose: () => void }) {
   const { state: sessionState } = useContext(SessionContext);
   const { state: applicationState, dispatch: applicationStateDispatch } = useContext(ApplicationStateContext);

   return (
      <AdvancedDragModal onClose={props.onClose}
         window={props.managedWindow}
         title={"Shows the contents of Access Rights"}
         subHeaderContent={<span>Customer: "{sessionState.customerRef}" User: "{sessionState.userRef}"</span>}
      >
         <ADModalBody >
            <div style={{ textAlign: "left" }}>
               <h4 style={{ height: "unset" }}>Roles</h4>
               {applicationState.availableRoles ? applicationState.availableRoles.sort().map((role, idx) => {
                  return (
                     <div key={role + idx} >{role}</div>
                  )
               }) : "no roles"}
               <h4 style={{ height: "unset" }}>All Features</h4>
               {applicationState.features ? applicationState.features.sort((a, b) => a <= b ? -1 : 1).map((feature, idx) => {
                  return (
                     <Fragment key={feature + idx}>
                        <GlassCheckbox // prettier-ignore
                           checked={applicationState.availableFeatures?.includes(feature)}
                           onClick={() => {
                              if (applicationState.availableFeatures?.includes(feature)) {
                                 applicationStateDispatch(actionRemoveAvailableFeature(feature));
                              } else {
                                 applicationStateDispatch(actionAddAvailableFeature(feature));
                              }
                           }
                           }
                           key={feature}
                        >{feature}</GlassCheckbox>
                     </Fragment>
                  )
               }) : "no features2"}
            </div>
         </ADModalBody>
      </AdvancedDragModal>
   );
}